import { isAndroid, isIOS, isInsideAPP } from "./platforms"
import config from "../config/env"

const shareTitle = "金哥宝箱，助您战“疫”"
const shareContent = "累计四周，周周壕礼，金哥宝箱邀您来战。"
const shareImage =
  "https://fintechapp-prd-1258285289.cos.ap-guangzhou.myqcloud.com/ops/2020-04/1585710740851-2be1fffce7d7482dbbf9dd33aac62a2c.png"

const wechatShare = function (cb) {
  if (isInsideAPP) {
    const msg = `{ "text": "累计四周，周周壕礼，金哥宝箱邀您来战。" }`
    if (isAndroid) {
      if (window.CgwsH5JS.setShareInfo) {
        window.CgwsH5JS.setShareInfo(msg)
      }
    }
    if (isIOS) {
      var setupWebViewJavascriptBridge = function setupWebViewJavascriptBridge(
        callback
      ) {
        if (window.WebViewJavascriptBridge) {
          return callback(window.WebViewJavascriptBridge)
        }

        if (window.WVJBCallbacks) {
          return window.WVJBCallbacks.push(callback)
        }

        window.WVJBCallbacks = [callback]
        var WVJBIframe = document.createElement("iframe")
        WVJBIframe.style.display = "none"
        WVJBIframe.src = "https://__bridge_loaded__"
        document.documentElement.appendChild(WVJBIframe)
        setTimeout(function () {
          document.documentElement.removeChild(WVJBIframe)
        }, 0)
      }

      setupWebViewJavascriptBridge(function (bridge) {
        if (msg) {
          bridge.registerHandler("getContentText", function (
            data,
            responseCallback
          ) {
            responseCallback(msg)
          })
        }
      })
    }
  } else {
    var newUrl = window.location.href.split("&")[0]
    var oimgUrl = shareImage
    var xhr = new XMLHttpRequest()
    xhr.open("POST", config.WECHAT_HOST + "/m/rest/wechat/getJssdkSignature")
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
    xhr.send(`url=${newUrl}`)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var data = JSON.parse(xhr.responseText)
        if (data.status === "1") {
          var newAppID = data.data.appid
          var newTime = data.data.timestamp
          var newNonceStr = data.data.nonceStr
          var newSign = data.data.signature
          // console.log(newAppID,newTime,newNonceStr,newSign,wx,newUrl);
          window.wx.config({
            debug: false,
            appId: newAppID,
            timestamp: newTime,
            nonceStr: newNonceStr,
            signature: newSign,
            jsApiList: [
              //调用了两个分享接口,分别是朋友圈和个人
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
            ],
          })
          window.wx.ready(function () {
            let obj = {
              title: shareTitle, //  标题
              desc: shareContent, //  描述
              link: newUrl, //  分享的URL，必须和当前打开的网页的URL是一样的
              imgUrl: oimgUrl, //  缩略图地址
            }
            window.wx.onMenuShareAppMessage({
              title: obj.title,
              desc: obj.desc,
              link: obj.link,
              imgUrl: obj.imgUrl,
            })
            window.wx.onMenuShareTimeline({
              title: obj.title,
              desc: obj.desc,
              link: obj.link,
              imgUrl: obj.imgUrl,
            })
          })
        }
      }
    }
  }
}

export { wechatShare }
